<template>
  <span>
    <v-btn
      v-tooltip.top="'WhatsApp Template'"
      icon
      style="margin: 0"
      @click="whatsappTemplateDialogOpen = true"
    >
      <i class="fab fa-whatsapp" style="font-size: 22px"></i>
    </v-btn>

    <v-dialog
      v-model="whatsappTemplateDialogOpen"
      width="1000px"
      persistent
      style="display: contents"
    >
      <v-card class="pa-3">
        <v-layout justify-end>
          <v-btn icon flat @click="whatsappTemplateDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <TemplateList :is-live-chat="true" @sendToLivechat="sendToLivechat" />
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import TemplateList from '../whatsapp/TemplateManagement/TemplateList.vue'

export default {
  components: {
    TemplateList
  },
  data() {
    return {
      whatsappTemplateDialogOpen: false
    }
  },
  methods: {
    sendToLivechat(template) {
      this.whatsappTemplateDialogOpen = false
      this.$emit('sendToLivechat', template)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatWhatsAppTemplate.vue